import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';

export default function Navbar() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isFloorPlansOpen, setIsFloorPlansOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Close mobile menu when route changes
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);

  return (
    <>
      {/* Main Navigation */}
      <motion.nav 
        initial={{ y: -100 }}
        animate={{ y: 0 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled ? 'bg-white/95 backdrop-blur-md shadow-lg py-1' : 'bg-transparent py-2'
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 lg:px-8">
          <div className="flex justify-between items-center h-14 md:h-16">
            {/* Logo */}
            <Link to="/" className="flex items-center relative z-10 mt-2">
              <img
                src="https://static.readdy.ai/image/462a574349d19c517babfc55bf63e079/c8ac21bc970c8b7e4f4c5b80839b9d5d.png"
                alt="KARE YAPI İNŞAAT Logo"
                className={`transition-all duration-300 object-contain ${scrolled ? 'h-16 md:h-20' : 'h-24 md:h-32 scale-110 drop-shadow-[0_0_15px_rgba(255,255,255,0.7)]'}`}
              />
            </Link>

            {/* Desktop Menu */}
            <div className="hidden lg:flex items-center gap-8">
              {['ANA SAYFA', 'KARE YAPI', 'HİZMETLER', 'GALERİ', 'İLETİŞİM'].map((item, index) => {
                const paths = ['/', '/about', '/services', '/gallery', '/contact'];
                return (
                  <Link 
                    key={item} 
                    to={paths[index]} 
                    className={`font-bold text-sm transition-colors whitespace-nowrap tracking-wide ${
                      scrolled 
                        ? 'text-slate-800 hover:text-red-600' 
                        : 'text-white/90 hover:text-white drop-shadow-md'
                    }`}
                  >
                    {item}
                  </Link>
                )
              })}
              
              <Link to="/floor-plans" className={`font-bold text-sm transition-colors whitespace-nowrap tracking-wide ${
                  scrolled ? 'text-slate-800 hover:text-red-600' : 'text-white/90 hover:text-white drop-shadow-md'
                }`}>
                KAT PLANLARI
              </Link>
              
              <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
                <Link to="/catalog" className="bg-red-600 text-white px-6 py-2.5 rounded-xl font-bold text-sm hover:bg-red-700 transition-all shadow-lg shadow-red-600/30 whitespace-nowrap flex items-center gap-2">
                  <i className="ri-book-read-line"></i>
                  E-KATALOG
                </Link>
              </motion.div>
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors ${
                scrolled ? 'text-slate-800 hover:bg-slate-100' : 'text-white hover:bg-white/10'
              }`}
            >
              <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Menu Backdrop & Content */}
        <AnimatePresence>
          {isMobileMenuOpen && (
            <motion.div 
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: 'auto' }}
              exit={{ opacity: 0, height: 0 }}
              transition={{ duration: 0.3 }}
              className="lg:hidden bg-white border-t border-slate-100 overflow-hidden shadow-2xl"
            >
              <div className="px-6 py-6 space-y-4">
                {['ANA SAYFA', 'KARE YAPI', 'HİZMETLER', 'GALERİ', 'İLETİŞİM'].map((item, index) => {
                  const paths = ['/', '/about', '/services', '/gallery', '/contact'];
                  return (
                    <Link key={item} to={paths[index]} className="block py-2 text-slate-800 hover:text-red-600 font-bold text-sm tracking-wide">
                      {item}
                    </Link>
                  )
                })}
                
                <div className="py-2 border-y border-slate-100 my-2">
                  <Link
                    to="/floor-plans"
                    className="w-full flex justify-between items-center py-2 text-slate-800 hover:text-red-600 font-bold text-sm tracking-wide transition-colors"
                  >
                    KAT PLANLARI
                  </Link>
                </div>

                <Link to="/catalog" className="block w-full text-center bg-red-600 text-white rounded-xl py-3 mt-4 font-bold text-sm shadow-lg shadow-red-600/20">
                  <i className="ri-book-read-line mr-2"></i> E-KATALOG İNDİR
                </Link>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </motion.nav>
    </>
  );
}
